import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { formatCurrency } from 'Helpers/UiHelper';

const PALETTE = ['#e74a3b', '#f6c23e', '#4e73df', '#1cc88a', '#36b9cc'];

const TopDestinationsChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-center text-muted">No data available</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          dataKey="cost"
          nameKey="country"
          innerRadius={60}
          outerRadius={110}
          label={({ country, percent }) => `${country} (${(percent * 100).toFixed(0)}%)`}
        >
          {data.map((entry, idx) => (
            <Cell key={`dest-slice-${entry.country}`} fill={PALETTE[idx % PALETTE.length]} />
          ))}
        </Pie>
        <Tooltip formatter={(value) => [formatCurrency(value), 'Cost']} />
      </PieChart>
    </ResponsiveContainer>
  );
};

TopDestinationsChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      country: PropTypes.string.isRequired,
      cost: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default TopDestinationsChart;
